var $8a32d0979ce8356e$exports = {};
$8a32d0979ce8356e$exports = {
    "endTime": `Beigu laiks`,
    "startTime": `S\u{101}kuma laiks`,
    "time": `Laiks`
};


export {$8a32d0979ce8356e$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
